import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisViewDetailChartData } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.model'
import { StatisticalAnalysisDossiersDatasourceResponsesTypes } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { incidentsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.service'
import { StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent } from '@/modules/statistical-analysis-module/services/incidents/incidents-dossier.dto'
import { StatisticalAnalysisViewDetailTableFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'

export class StatisticalAnalysisHandlerExternalChartIncidentsDossier {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>
    private row!: StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>, row: StatisticalAnalysisDossiersDatasourceResponsesTypes) {
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
        this.row = row as StatisticalAnalysisIncidentsStatisticsDossierDetailViewTableContent
    }

    public async getChart(): Promise<StatisticalAnalysisViewDetailChartData> {
        const incidentsIds: number[] = []
        return incidentsStatisticsDossierService.getExternalViewDetailChartList(incidentsIds)
    }
}
